var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgZmw = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6957 12.2673H12V24.2673C13.4027 24.2673 14.7488 24.0259 16 23.5836L16.6957 12.2673Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 21.2108C22.4551 19.0135 24.0004 15.8211 24.0004 12.2673H19.3047L20.0003 21.2108Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 12.2673V23.5836C17.4905 23.0567 18.8458 22.2439 20 21.2108V12.2673H16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.174 8.09207H19.0436C19.0436 7.51579 18.5764 7.04858 18.0001 7.04858C17.4238 7.04858 16.9566 7.51579 16.9566 8.09207H13.8262C13.8262 8.6684 14.3282 9.13555 14.9044 9.13555H14.8697C14.8697 9.71188 15.3368 10.179 15.9131 10.179C15.9131 10.7554 16.3803 11.2225 16.9566 11.2225H19.0436C19.6199 11.2225 20.0871 10.7554 20.0871 10.179C20.6634 10.179 21.1306 9.71188 21.1306 9.13555H21.0958C21.6721 9.13551 22.174 8.66835 22.174 8.09207Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZmw);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ZMW.59609043d8a90e557fc7f2c3b1b2516d.svg";